import { useEffect, useRef, useState } from "react";
import { modelPrices, models } from "utils/models";

export const ModelPriceDropdown: React.FC = () => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleOutside(e: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [open]);

  const toggle = () => setOpen(!open);

  return (
    <div ref={wrapperRef} className="position-relative d-inline-block">
      <button
        className="btn btn--ordinary btn--medium price_btn"
        onClick={toggle}
      >
        Prices
      </button>

      {open && (
        <div
          className="dropdown-menu price_popup border_radius_8 p-3 bg_color_snow_white show shadow-lg"
          style={{
            width: 420,
            maxHeight: 360,
            overflowY: "auto",
            right: 0,
            left: "auto"
          }}
        >
          <table className="table table-sm mb-0 text-nowrap">
            <thead className="thead-dark sticky-top">
              <tr>
                <th style={{ width: "40%" }}>Model</th>
                <th>Input</th>
                <th>Cached input</th>
                <th>Output</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(models).map(([id, label]) => {
                const p = modelPrices[id as keyof typeof models];
                if (!p) return null;
                return (
                  <tr key={id}>
                    <td>{label}</td>
                    <td>{p.input}</td>
                    <td>{p.cached}</td>
                    <td>{p.output}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
